import API_PATH from '../../../config/API_PATH'
import { GET_BANNER_HOME, GET_BID_PRODUCT, TYPE_INTRO_TOUR, SET_ADVER_TISEMENT, GET_TOTAL_USER_BID, GET_UP_NEXT_PRODUCT, SET_SHWE_HOURS_ICON } from './contants'

export const setReduxDataTypeIntroTour = (data) => {
	return {
		type: TYPE_INTRO_TOUR,
		data
	}
}

export const setReduxClosePopupAdvertisement = (data) => {
	return {
		type: SET_ADVER_TISEMENT,
		data
	}
}

export const getBidProduct = data => {
	return {
		type: GET_BID_PRODUCT,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.bidProduct,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getUpNextProduct = data => {
	return {
		type: GET_UP_NEXT_PRODUCT,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.upNextProduct,
			query: data.query || {},

		},
	}
}
export const getBannerHome = data => {
	return {
		type: GET_BANNER_HOME,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.banner,
			query: data.query || {},

		},
	}
}

export const setShweHoursIconData = (data) => {
  return {
    type: SET_SHWE_HOURS_ICON,
    data,
  }
}
